<template>
  <v-card>
    <v-card-title class="headline"
      >Generar reporte
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        :loading="loading"
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-select
              :items="items"
              filled
              clearable
              :loading="loading"
              v-model="selectedType"
              label="Datos"
              rounded
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value="date"
              persistent
              width="350"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Filtrar por fecha"
                  readonly
                  filled
                  :loading="loading"
                  rounded
                  hide-details
                  :disabled="loading"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                range
                :title-date-format="title"
                scrollable
                :max="today"
              >
                <v-row no-gutters style="flex-wrap: nowrap">
                  <v-btn
                    class="flex-grow-1 flex-shrink-0"
                    large
                    rounded
                    outlined
                    color="primary"
                    @click="modal = false"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    class="flex-grow-1 flex-shrink-0"
                    large
                    rounded
                    color="primary"
                    @click="$refs.dialog.save(date)"
                  >
                    Aceptar
                  </v-btn>
                </v-row>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="12" sm="12" md="12" class="mb-3 pb-0 mt-3">
            <v-btn
              rounded
              @click="next"
              filled
              :loading="loading"
              block
              height="50"
              color="primary"
            >
              Generar
            </v-btn></v-col
          >
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
import { fb } from "@/firebase";
import axios from "axios";

export default {
  name: "filters",
  props: ["originalStatus", "originalDate", "tab"],
  data() {
    return {
      loading: false,
      modal: false,
      selectedStatus: [],
      selectedType: null,
      items: [
        { value: "1", text: "Mandados" },
        { value: "2", text: "Enlaces de Pago" },
      ],
      //   status: [
      //     { value: "placed", text: "Colocada" },
      //     { value: "accepted", text: "Aceptada" },
      //     { value: "enRoute", text: "Chavo en Camino al Comercio" },
      //     { value: "onDelivery", text: "Chavo en Camino al Cliente" },
      //     { value: "delivered", text: "Entregada al Cliente" },
      //     { value: "completed", text: "Orden Completada" },
      //     { value: "canceled", text: "Cancelada por Dilo" },
      //     { value: "pendingValidation", text: "Requiere Validación" },
      //     { value: "rejected", text: "Rechazada por el Negocio" },
      //   ],
      //   payLinksStatus : [
      //     { value: "paid", text: "Pagado" },
      //     { value: "pending", text: "Pendiente" },
      //     { value: "canceled", text: "Cancelado" },
      //     { value: "expired", text: "Expiró" },
      //   ],
      date: [
        `${moment()
          .tz("America/Tegucigalpa")
          .startOf("month")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
        `${moment()
          .tz("America/Tegucigalpa")
          .subtract(6, "hours")
          .toISOString()
          .substr(0, 10)}`,
      ],
    };
  },
  computed: {
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },

  methods: {
    getSectionToken() {
      return new Promise((resolve, reject) => {
        fb.auth()
          .currentUser.getIdToken(true)
          .then((token) => {
            resolve(token);
          });
      });
    },
    title() {
      return "Selecciona un rango de fechas";
    },

    async next() {
      this.loading = true;

      let token = await this.getSectionToken();

      let data = {
        startDate: this.date[0],
        endDate: this.date[1],
        type: this.selectedType,
      };

      axios
        .post(
          `${process.env.VUE_APP_FUNCTIONS_URL}/httpCargoReports`,
          data,
          { headers: { Authorization: `Basic ${token}` }, responseType: "blob" }
        )
        .then((response) => {
          const { data, headers } = response;
          const fileName = `Reporte ${this.date[0]} al ${this.date[1]}.xlsx`;

          const blob = new Blob([data], { type: headers["content-type"] });
          let dom = document.createElement("a");
          let url = window.URL.createObjectURL(blob);
          dom.href = url;
          dom.download = decodeURI(fileName);
          dom.style.display = "none";
          document.body.appendChild(dom);
          dom.click();
          dom.parentNode.removeChild(dom);
          window.URL.revokeObjectURL(url);

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
        });
    },
  },

  mounted() {
    if (this.tab) {
      this.selectedType = this.tab;
    }
  },
};
</script>